import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, useHistory, useLocation, useParams } from "react-router";
import { Route, Switch } from "react-router-dom";
import { ApiError } from "go-core/api/types";
import { LoadingContainer } from "go-core/components/Loading";
import { OrderData } from "../../../../../services/Api/Public/types";
import { OrderContext } from "../contexts/OrderContext";
import { useOrder } from "../hooks";
import { getOrderBackRedirect } from "../utils";
import EOrderCustomTipPage from "./CustomTip";
import EOrderPaymentPage from "./Payment";
import EOrderIndexPage from "./Preview";
import EOrderTipPage from "./Tip";

interface MatchParams {
	orderId: string;
}

export const EOrderPage = (props: RouteComponentProps): JSX.Element => {
	const { orderId } = useParams<MatchParams>();
	const [order, setOrder] = useState<OrderData>();
	const [tipAmount, setTipAmount] = useState<number>();
	const [paymentSuccess, setPaymentSuccess] = useState(false);
	const [errors, setErrors] = useState<ApiError[]>([]);
	const { t } = useTranslation();
	const history = useHistory();
	const location = useLocation();
	const [redirectUrl, setRedirectUrl] = useState<string>("");
	useOrder(orderId, props.match.url, setOrder, setErrors, order, paymentSuccess);

	useEffect(() => {
		window.parent.postMessage({ type: "IFRAME_READY" }, "*");

		const onMessage = (event: MessageEvent) => {
			if (event.data && typeof event.data === "object" && "navigate_inside_iframe" in event.data) {
				const navigateInsideIframe = event.data.navigate_inside_iframe;
				if (navigateInsideIframe === true) {
					history.replace(getOrderBackRedirect(props.match.url, order, location));
				}
			}

			if (event.data && typeof event.data === "object" && "parent_redirect_url" in event.data) {
				const parentRedirectUrl = event.data.parent_redirect_url;
				setRedirectUrl(parentRedirectUrl);
			}
		};

		window.addEventListener("message", onMessage);
		return () => window.removeEventListener("message", onMessage);
	}, []);

	if (!order)
		return (
			<div className="eorder">
				<main>
					<LoadingContainer />
					{errors.length > 0 && (
						<div className="alert alert-danger">
							{t(`${"constraints."}${errors[0].message}`, { ns: ["translation", "lib"] })}
						</div>
					)}
				</main>
			</div>
		);

	return (
		<OrderContext.Provider
			value={{
				orderId,
				order,
				setOrder,
				matchUrl: props.match.url,
				tipAmount,
				setTipAmount,
				setPaymentSuccess,
				paymentSuccess,
				errors,
				setRedirectUrl,
				redirectUrl,
			}}
		>
			<div className="eorder" data-testid="e-order-container">
				<Switch>
					<Route exact path={`${props.match.url}/tip`} component={EOrderTipPage} />
					<Route exact path={`${props.match.url}/custom_tip`} component={EOrderCustomTipPage} />
					<Route exact path={`${props.match.url}/payment`} component={EOrderPaymentPage} />
					<Route exact path={props.match.url} component={EOrderIndexPage} />
				</Switch>
			</div>
		</OrderContext.Provider>
	);
};
